import { FETCH_ORDER_HISTORY_SUCCESS, FETCH_ORDER_HISTORY_REQUEST, FETCH_ORDER_HISTORY_ERROR } from '../constants/ActionTypes'

export default function fetchOrderHistoryError(state = { recent: false, past: false }, action) {
    switch (action.type) {
        case FETCH_ORDER_HISTORY_REQUEST:
        case FETCH_ORDER_HISTORY_SUCCESS:
            return {
                ...state,
                [action.payload.category]: false
            }

        case FETCH_ORDER_HISTORY_ERROR:
            return {
                ...state,
                [action.payload.category]: true
            }
        default:
            return state
    }
}
